
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tagi/[slug]",
      function () {
        return require("private-next-pages/tagi/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tagi/[slug]"])
      });
    }
  